import { ImageLoaderProps } from "next/legacy/image";

import { base64encode, base64decode } from "./base64";

const VAULT_IMAGE_PREFIX = "https://images.holibob.tech/";

export const SIZES = [300, 600, 900, 1280, 1200, 1536, 2048, 2560, 3440, 3840, 4096];

/**
 * Given a vault image url like https://images.holibob.tech/asdfasdfasdfasdfasdfasdf
 * Extract the base64 data, apply edits and return the resulting vault image url
 */
export const editVaultImage = (imageUrl: string, edits?: Record<string, unknown>) => {
    if (!imageUrl.startsWith(VAULT_IMAGE_PREFIX) || !edits) {
        return imageUrl;
    }
    try {
        const base64 = imageUrl.substring(VAULT_IMAGE_PREFIX.length);
        const json = JSON.parse(base64decode(base64));
        return VAULT_IMAGE_PREFIX + base64encode(JSON.stringify({ ...json, edits }));
    } catch (e) {
        return imageUrl;
    }
};

function createVaultURL({
    id,
    folder,
    bucket,
    edits,
}: {
    id: string;
    folder?: string;
    bucket?: string;
    edits?: Record<string, unknown>;
}) {
    const key = folder ? `${folder}/${id}` : id;

    const imageObject: Record<string, unknown> = {
        bucket,
        key,
        edits,
    };

    const base64data = base64encode(JSON.stringify(imageObject));
    return `https://images.holibob.tech/${base64data}`;
}

/**
 * Allow next/image to load raw vault image urls and apply resize to them
 */
export const vaultUrlLoader = ({
    src,
    width,
    height,
}: {
    height?: number;
} & ImageLoaderProps) => {
    return editVaultImage(src, { resize: { fit: "cover", width, height } });
};

export const productImageLoader = ({
    src,
    width,
    height,
}: {
    height?: number;
} & ImageLoaderProps) => {
    return createVaultURL({
        id: src,
        edits: {
            resize: {
                fit: "cover",
                width,
                height,
            },
        },
        folder: "productImages",
    });
};
